<template>
<v-container>
  <v-row justify="center">
    <v-col ref="signature-container" md="5" cols="12">
      <v-row>
        <v-col cols="12">
          <vue-drawing-canvas
            ref="signature-board"
            :styles="{
            border: 'solid 1px #000',
          }"
            :line-width="3"
            :width="width"
            :height="height"
            :background-image="backgroundImage"
          />
        </v-col>
        <v-col cols="6">
          <v-file-input style="padding: 0 !important" @change="onLoad">Load</v-file-input>
        </v-col>
        <v-col cols="6">
          <v-btn @click="onReset">Reset</v-btn>
          <v-btn @click="onSave">Save</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-spacer></v-spacer>
    <v-col md="5" cols="12">
      <img v-if="signature" :src="signature" style="max-block-size: fit-content" />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import VueDrawingCanvas from 'vue-drawing-canvas';

export default {
  name: "signature-board",
  props: {
    signature: {
      type: String,
      default: null
    }
  },
  components: {
    VueDrawingCanvas
  },
  data: function() {
    return {
      width: 500,
      height: 250,
      ignoreResize: false,
      backgroundImage: null,
    };
  },
  methods: {
    async onLoad(e) {
      this.backgroundImage = e ? window.URL.createObjectURL(e) : null;
      await this.$refs['signature-board'].redraw();
    },
    onReset() {
      this.$refs['signature-board'].reset();
    },
    onSave() {
      const canvas = this.$refs['signature-board'].$el;
      if (canvas) {
        const self = this;
        canvas.toBlob((blob) => {
          self.$el.dispatchEvent(new CustomEvent('save', { bubbles: true, detail: blob }));
        }, 'image/jpeg', 0.95);
      }
    },
  }
}
</script>
